import { fromBase64 } from '@change-corgi/core/base64';

const splitDataUri = (dataUri: string): { header: string; data: string } => {
	const [header, data] = dataUri.split(',');
	if (header === undefined || data === undefined) {
		throw new Error('Invalid data URI');
	}
	return { header, data };
};

/** Extracts the mime component from a data URI header. */
const getMimeString = (header: string): string => header.split(':')[1]?.split(';')[0] ?? '';

export const dataUriToBlob = (dataUri: string): Blob => {
	const { header, data } = splitDataUri(dataUri);
	// convert base64/URLEncoded data component to raw binary data held in a string
	const byteString = header.includes('base64') ? fromBase64(data) : unescape(data);

	const mimeString = getMimeString(header);

	// write the bytes of the string to a typed array
	const ia = new Uint8Array(byteString.length);
	for (let i = 0; i < byteString.length; i += 1) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ia], { type: mimeString });
};

export const dataUriToBlobAsync = async (dataUri: string): Promise<Blob> => {
	// oxlint-disable-next-line promise/avoid-new
	return new Promise((resolve, reject) => {
		try {
			const { header, data } = splitDataUri(dataUri);
			const byteString = header.includes('base64') ? atob(data) : unescape(data);

			const mimeString = getMimeString(header);

			// write the bytes of the string to a typed array
			const ia = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i += 1) {
				ia[i] = byteString.charCodeAt(i);
			}

			resolve(new Blob([ia], { type: mimeString }));
		} catch (error) {
			reject(new Error('Could not convert data URI to Blob'));
		}
	});
};
